/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No posts found.`)
};

const es_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron artículos.`)
};

const de_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Beiträge gefunden.`)
};

const nl_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen berichten gevonden.`)
};

const fr_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun article trouvé.`)
};

const it_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun articolo trovato.`)
};

const pt_br2_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum artigo encontrado.`)
};

const pt_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum artigo encontrado.`)
};

const ja_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`記事が見つかりませんでした。`)
};

const zh_blog_no_posts = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到文章。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const blog_no_posts = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.blog_no_posts(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("blog_no_posts", locale)
	if (locale === "en") return en_blog_no_posts(inputs)
	if (locale === "es") return es_blog_no_posts(inputs)
	if (locale === "de") return de_blog_no_posts(inputs)
	if (locale === "nl") return nl_blog_no_posts(inputs)
	if (locale === "fr") return fr_blog_no_posts(inputs)
	if (locale === "it") return it_blog_no_posts(inputs)
	if (locale === "pt-BR") return pt_br2_blog_no_posts(inputs)
	if (locale === "pt") return pt_blog_no_posts(inputs)
	if (locale === "ja") return ja_blog_no_posts(inputs)
	return zh_blog_no_posts(inputs)
};